import $ from 'jquery';

export default function() {
    this.resetValidationErrors = function(e, data) {
        this.$node.find('.field[data-field-error]').removeAttr('data-field-error');
        this.$node.find('.field__validation, .fieldset__validation').empty();
    };

    this.checkForValidationErrors = function(e, data) {
        if (data.status === 'validation') {
            var component = this;

            $.each(data.content, function(i, v) {
                component.displayErrorsForField($('[name="' + i + '"]'), v);
            });

            this.trigger('errorsPopulated');
        }
    };

    this.displayErrorsForField = function($input, errors) {
        if (!$.isArray(errors)) {
            errors = [errors];
        }
        $input.closest('.field').attr('data-field-error', '');

        var $validationContainer = $('#' + $input.data('validationMessageContainer'));
        var validationContainerType = $validationContainer.data('validationType');
        var component = this;

        if ($validationContainer.length) {
            $.each(errors, function(i, error) {
                $validationContainer.append(
                    component.template(component.errorTemplate[validationContainerType], {
                        error_message: error, // eslint-disable-line camelcase
                    })
                );
            });
        }
    };

    this.template = function(template, args) {
        $.each(args, function(i, v) {
            i = '%%' + i + '%%';
            template = template.replace(i, v);
        });
        return template;
    };

    this.attributes({
        errorTemplate: {
            field: '',
            fieldset: '',
        },
    });

    this.after('initialize', function() {
        this.errorTemplate = {
            field: this.$node.data('fieldErrorTemplate'),
            fieldset: this.$node.data('fieldsetErrorTemplate'),
        };

        this.on('asyncFormProcessing', this.resetValidationErrors);
        this.on('asyncFormSuccess', this.checkForValidationErrors);
    });
}



// WEBPACK FOOTER //
// ./src/web/js/launch/modules/mixins/with-async-validation.js